import { useState } from "react";

export function useLoadAndSyncInvoicePdf() {
  const [coordinates, setCoordinates] = useState<any>(undefined);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [pdfBlob, setPdfBlob] = useState<string | null>(null);

  return {
    pdfBlob,
    setPdfBlob,
    coordinates,
    errorMessage,
    setCoordinates,
    setErrorMessage,
  };
}
